import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useClientesListaFilters
 */

type State = {
    idsCliente?: number[],
    cidade?: string | null,
    data?: Date | null,
    status?: number,
};

type Action = {
    setIdsCliente: (idsCliente?: number[]) => void;
    setCidade: (cidade?: string | null) => void;
    setData: (data?: Date | null) => void;
    setStatus: (status?: number) => void;
    clearFilters: () => void;
};

export const useNovosNegociosListaFilters = create<State & Action>((set) => ({
    idsCliente: [],
    cidade: undefined,
    data: undefined,
    status: 4,
    setIdsCliente: (idsCliente) => set({ idsCliente }),
    setCidade: (cidade) => set({ cidade }),
    setData: (data) => set({ data }),
    setStatus: (status) => set({ status }),
    clearFilters: () => set({
        idsCliente: [],
        cidade: null,
        data: null,
        status: 4,

    }),
}));

export const initialNovosNegociosFiltersValues: State = {
    idsCliente: [],
    cidade: null,
    data: null,
    status: 4,
};